import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import StarRating from './StarRating';
import { IOSSheet } from './ios';

function RatingBottomSheet({ rating = 0, onRate, title, size = 14 }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleTapTarget = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(true);
  }, []);

  const handleRate = useCallback((newRating) => {
    onRate(newRating);
  }, [onRate]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <div
        className="rating-bottom-sheet__trigger"
        onClick={handleTapTarget}
        role="button"
        tabIndex={0}
        aria-label={t('rating.yourRating')}
      >
        <StarRating rating={rating} size={size} readOnly />
      </div>

      {ReactDOM.createPortal(
        <IOSSheet
          isOpen={isOpen}
          onClose={handleClose}
          title={title}
          height="auto"
        >
          <div className="rating-bottom-sheet__content">
            <p className="rating-bottom-sheet__label">
              {t('rating.yourRating')}
            </p>
            <div className="rating-bottom-sheet__stars">
              <StarRating
                rating={rating}
                onRate={handleRate}
                size={34}
              />
            </div>
            {rating > 0 && (
              <p className="rating-bottom-sheet__value">
                {rating} / 5
              </p>
            )}
          </div>
        </IOSSheet>,
        document.body
      )}
    </>
  );
}

export default RatingBottomSheet;
